import React from 'react';
import PayYourLoan from '../../feature/payYourLoan';
import useStyles from './styles';

export default function LoanPayment() {
  const classes = useStyles();
  return (
    <div className={classes.contentContainer}>
      <PayYourLoan
        open
        pageCategory="SITIO WEB"
      />
    </div>
  );
}
